<template>
  <div class="content">
    <alta-de-chips ref="altaDeChips"></alta-de-chips>
    <modificar-chip
      @chipUpdated="chipUpdated"
      ref="modificarChip"
    ></modificar-chip>

    <div class="container-fluid h-100">
      <div class="container-fluid h-100">
        <div class="row h-100">
          <div class="col h-100">
            <card-item
              class="striped-tabled-with-hover"
              body-classes="table-full-width table-responsive"
            >
              <template slot="header">
                <div class="d-flex justify-content-between">
                  <div>
                    <h4 class="card-title">Chips</h4>
                    <p class="card-category">Listado</p>
                  </div>
                  <div class="button-group">
                    <button @click="altaDeChip" class="btn btn-primary">
                      Alta de Chips
                    </button>
                  </div>
                </div>
              </template>

              <div class="container-fluid h-100">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="quickFilter" class="label"
                        >Filtro rapido</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="quickFilter"
                        v-model="quickFilter"
                      />
                    </div>
                  </div>
                </div>
                <div class="row" style="height: 100%">
                  <div class="col" style="position: relative; height: 100%">
                    <ag-grid-vue
                      style="width: 100%; height: 60vh"
                      class="ag-theme-alpine"
                      @grid-ready="onGridReady"
                      :gridOptions="gridOptions"
                      :columnDefs="columnDefs"
                      :defaultColDef="defaultColDef"
                      :modules="modules"
                      rowSelection="multiple"
                      :getContextMenuItems="getContextMenuItems"
                      :rowMultiSelectWithClick="true"
                      :rowData="rowData"
                    >
                    </ag-grid-vue>
                  </div>
                </div>
              </div>
            </card-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import { AllModules } from "ag-grid-enterprise";
import moment from "moment";
import AltaDeChips from "./ABM/AltaDeChips";
import ModificarChip from "./ABM/ModificarChip";

export default {
  name: "ChipsList",
  components: { AgGridVue, AltaDeChips, ModificarChip },
  beforeMount() {
    this.gridOptions = {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true, // Habilita Ctrl+C/Ctrl+V (por defecto es true)
      enableRangeSelection: true, // Permite seleccionar rangos de celdas
    };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      enableCellTextSelection: true,
      // cellClass: "ag-center-cols-cell",
    };
  },
  mounted() {
    document.getElementsByClassName("ag-watermark")[0].style.display = "none";
  },

  computed: {
    rowData: {
      get() {
        return this.$store.getters["chips/getChips"];
      },
      set(val) {
        this.$store.commit("chips/setChips", val);
      },
    },
  },

  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.showLoadingOverlay();
      this.$store.dispatch("chips/getChips").then(() => {
        this.gridApi.hideOverlay();
        setTimeout(() => this.autoSizeAll(false), 50);
      });
    },
    autoSizeAll(skipHeader) {
      let allColumnIds = [];
      this.columnApi.getAllColumns().forEach(function (column) {
        // Usar columnApi
        allColumnIds.push(column.colId);
      });
      this.columnApi.autoSizeColumns(allColumnIds, skipHeader); // Usar columnApi
    },
    altaDeChip() {
      this.$refs.altaDeChips.$refs.modal.show();
    },
    resumenDeChips() {
      this.$refs.resumenDeChips.$refs.modal.show();
    },
    modificarChip(node) {
      this.modifyChipNodeId = node.id;
      this.$store.commit("chips/setChipForModify", {
        ...node.data,
        fecha_ingreso: this.$moment(node.data.fecha_ingreso).format(
          "YYYY-MM-DDTHH:mm:ss",
        ),
        fecha_baja: this.$moment(node.data.fecha_baja).format(
          "YYYY-MM-DDTHH:mm:ss",
        ),
      });
      this.$refs.modificarChip.$refs.modal.show();
    },
    chipUpdated(chipData) {
      let node = this.gridApi.getRowNode(this.modifyChipNodeId);
      node.setData(chipData);
      this.modifyChipNodeId = null;
    },
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
  },
  data: () => ({
    modifyChipNodeId: null,

    quickFilter: "",

    // ag-grid config
    modules: AllModules,

    gridOptions: null,
    gridApi: null,

    defaultColDef: null,
    columnDefs: [
      {
        headerName: "id",
        field: "id_chip",
        filter: false,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
      },
      {
        headerName: "Número",
        field: "numero",
      },
      {
        headerName: "IMSI",
        field: "IMSI",
      },
      {
        headerName: "Fecha de Ingreso",

        cellRenderer: (params) =>
          moment(params.data.fecha_ingreso).format("DD-MM-YYYY"),
        getQuickFilterText: (params) =>
          moment(params.data.Fecha).format("DD-MM-YYYY"),
        comparator: (valueA, valueB, nodeA, nodeB) => {
          return (
            new Date(nodeA.data.fecha_ingreso.substring(0, 10)) -
            new Date(nodeB.data.fecha_ingreso.substring(0, 10))
          );
        },
        valueGetter: (params) => {
          return moment(params.data.fecha_ingreso).format("DD-MM-YYYY");
        },
      },
      {
        headerName: "Empresa",
        field: "empresa",
      },
      {
        headerName: "Ubicación",
        field: "ubicacion",
      },
      {
        headerName: "Plan",
        field: "plan",
      },
    ],
  }),
  watch: {
    quickFilter(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
};
</script>
<style></style>
